import React from 'react';
import { useTranslation } from 'react-i18next';
import { PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { generateReactKey } from 'src/common/helpers/common.helpers';
import { getCorrectFormatEmployeeInfoField } from '../../employee-details.helpers';

import { PageTopbar } from 'src/components/employee/page-topbar';

import {  IPaymentAndInsuranceView } from '../../employee.interfaces';

import {
  InfoBlockContainer,
  PersonalInfoMainWrapper,
  StyledContainer,
  TitleRowLabel,
  InfoBlock,
  InfoElement,
} from '../../employee-common.styles';

const PaymentAndInsuranceView = ({
  paymentAndInsurance,
  onClickEdit,
  healthInsurance,
}: {
  paymentAndInsurance: IPaymentAndInsuranceView;
  onClickEdit: () => void;
  healthInsurance?: {
    name?: string;
  };
}) => {
  const { t } = useTranslation('employee');

  const {
    bankAccountHolder,
    iban,
    workPermissionExpireDate,
    workPermissionNeeded,
    residencePermissionExpireDate,
    residencePermissionNeeded,
    hasCertificateOfStudy,
    certificateOfStudyExpireDate,
    bic,
    taxId,
    nationalInsuranceNumber,
    healthInsuranceType,
    typeOfVisa,
    visaExpirationDate,
  } = paymentAndInsurance;

  const socialSecurityArray = [
    {
      taxId,
    },
    { insuranceNumber: nationalInsuranceNumber },
  ];

  const bankDataArray = [
    {
      bankAccountHolder,
    },
    { iban },
    {
      bic,
    },
  ];

  const insuranceArray = [
    {
      healthInsuranceType,
    },
    { healthInsuranceName: healthInsurance?.name },
  ];

  const residenceArray = [
    {
      typeOfVisa,
      workPermissionNeeded,
      residencePermissionNeeded,
      hasCertificateOfStudy,
    },
    {
      visaExpirationDate,
      workPermissionExpireDate,
      residencePermissionExpireDate,
      certificateOfStudyExpireDate,
    },
  ];

  return (
    <div>
      <PageTopbar
        pageTitle={t('labels.paymentAndInsurance')}
        onClickEdit={onClickEdit}
        createdBy={paymentAndInsurance.createdBy}
      />
      <PersonalInfoMainWrapper>
        <StyledContainer>
          <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {t('employee:labels.bankInformation')}
          </TitleRowLabel>
          <InfoBlock columns={'1fr 1fr 1fr'}>
            {bankDataArray.map(el => {
              return (
                <InfoBlockContainer key={generateReactKey()}>
                  {Object.entries(el).map(([key, value]) => {
                    return (
                      <InfoElement key={generateReactKey()}>
                        <Typography weight="bold">
                          {`${t(`employee:paymentAndInsurance.labels.${key}`)}`}:
                        </Typography>
                        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                          {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                        </Typography>
                      </InfoElement>
                    );
                  })}
                </InfoBlockContainer>
              );
            })}
          </InfoBlock>
        </StyledContainer>
        <StyledContainer>
          <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {t('employee:labels.socialSecurity')}
          </TitleRowLabel>
          <InfoBlock columns={'1fr 1fr 1fr'}>
            {socialSecurityArray.map(el => {
              return (
                <InfoBlockContainer key={generateReactKey()}>
                  {Object.entries(el).map(([key, value]) => {
                    return (
                      <InfoElement key={generateReactKey()}>
                        <Typography weight="bold">
                          {`${t(`employee:paymentAndInsurance.labels.${key}`)}`}:
                        </Typography>
                        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                          {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                        </Typography>
                      </InfoElement>
                    );
                  })}
                </InfoBlockContainer>
              );
            })}
          </InfoBlock>
        </StyledContainer>
        <StyledContainer>
          <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {t('employee:labels.insurance')}
          </TitleRowLabel>
          <InfoBlock columns={'1fr 1fr 1fr'}>
            {insuranceArray.map(el => {
              return (
                <InfoBlockContainer key={generateReactKey()}>
                  {Object.entries(el).map(([key, value]) => {
                    return (
                      <InfoElement key={generateReactKey()}>
                        <Typography weight="bold">
                          {`${t(`employee:paymentAndInsurance.labels.${key}`)}`}:
                        </Typography>
                        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                          {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                        </Typography>
                      </InfoElement>
                    );
                  })}
                </InfoBlockContainer>
              );
            })}
          </InfoBlock>
        </StyledContainer>
        <StyledContainer>
          <TitleRowLabel weight="bold" fontColor={PLATFORM_THEME_COLORS.grayVariations.dark}>
            {t('employee:labels.residenceStatus')}
          </TitleRowLabel>
          <InfoBlock columns={'1fr 1fr 1fr'}>
            {residenceArray.map(el => {
              return (
                <InfoBlockContainer key={generateReactKey()}>
                  {Object.entries(el).map(([key, value]) => {
                    return (
                      <InfoElement key={generateReactKey()}>
                        <Typography weight="bold">
                          {`${t(`employee:paymentAndInsurance.labels.${key}`)}`}:
                        </Typography>
                        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
                          {getCorrectFormatEmployeeInfoField({ t, key, value }) || '-'}
                        </Typography>
                      </InfoElement>
                    );
                  })}
                </InfoBlockContainer>
              );
            })}
          </InfoBlock>
        </StyledContainer>
      </PersonalInfoMainWrapper>
    </div>
  );
};

export default PaymentAndInsuranceView;
